export default __webpack_public_path__ + "25632b0d0f15463a003a4604e75a83ab.png";